export enum CarouselType {
    Quote = 'quote',
    Resource = 'resource',
    Program = 'program',
}
